export default __webpack_public_path__ + "static/media/plain-sticker-O.49efe19e.png";